// extracted by extract-css-chunks-webpack-plugin
module.exports = {"EmptyArea":"EmptyArea_1zsfQ_v13-0-0","VerticalNav":"VerticalNav_qU-wq_v13-0-0","Title":"Title_2J6CA_v13-0-0"};
    if(module.hot) {
      // 1588357788865
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  